export  const TagType = {

  ERROR: "error",
  SUCCESS: "success",
  PAGEVIEW: "pageview",
  INPUT: "input",
  BUTTON_DEFAULT: "button-default",
  BUTTON_MODAL: "button-modal",
  FOOTER_PORTAL: "footer-portal-de-privacidade",
  FOOTER_POLITICA: "footer-politica-de-privacidade",
  BUTTON_VOLTAR_MODAL: "button-voltar-modal",
  BUTTON_LEVEME_MODAL: "ok-leve-me-modal",
}



export  const TagTypeGa4 = {

  ERROR: "error",
  SUCCESS: "success",
  PAGEVIEW: "pageview",
  INPUT: "input-item",
  BUTTON: "click-item",
  BUTTON_MODAL: "click-item-modal",
  FOOTER: "footer",

}




export  const EventType = {

  CLIQUE: "clique",
  INTERACAO: "interacao",
  CALLBACK: "callback",
}


export  const factorType = {
TWO_FACTOR: "processo_autenticacao_2_fatores",
ONE_FACTOR: "processo_autenticacao_1_fator",
PRE_FACTOR: "pre_processo_autenticacao",
}
